import API_ROUTES from 'config/apiRoutes';
import http from 'shared/utils/http';

export type ChangeLog = {
  count: number;
  items: ChangeLogItem[];
  totalCount: string;
};

export type ChangeLogItem = {
  header: string;
  content: string;
  language: string;
  releaseDate: string;
  createdAt: string;
  updatedAt: string;
  imageUrl: string;
};

export async function fetchChangelog({ language }: { language: string }): Promise<ChangeLog | null> {
  const url = http.createApiUrl(API_ROUTES.CHANGELOG).replace(':language', language);
  const res = await fetch(url, { next: { revalidate: 3600 } }); // one hour
  if (!res.ok && res.status !== 404) {
    throw new Error('Failed to fetch faq data');
  }
  if (res.status === 404) {
    return null;
  }
  const data = await res.json();

  return data;
}
